import { Navigate, Outlet, useLocation } from 'react-router-dom'
import { useAuthStore } from '../store/auth'

/**
 * Wraps church admin routes.
 * Requires authentication + church_admin role.
 * Per-church authorization is enforced by the API (returns 403 if wrong church).
 */
export default function ChurchAdminRoute() {
  const { accessToken, user } = useAuthStore()
  const location = useLocation()

  if (!accessToken) {
    return <Navigate to="/login" state={{ from: location }} replace />
  }

  if (user && user.role !== 'church_admin' && user.role !== 'super_admin') {
    return <Navigate to="/" replace />
  }

  return <Outlet />
}
